import { ColorContext } from 'App';
import React, { useContext } from 'react';

export default function OvalDisplayHorizontal({
  header,
  content,
  style,
  headerStyle,
  contentStyle,
}) {
  const theme = useContext(ColorContext);
  return (
    <div
      className="p-3 rounded-4"
      style={{
        backgroundColor: theme.primary,
        ...style,
      }}
    >
      <div className="fw-bold fs-5" style={{ ...headerStyle }}>
        {header}
      </div>
      <div style={contentStyle}>{content}</div>
    </div>
  );
}
